// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__34c7M","boxTitle":"Qualiphy_boxTitle__2Xpfi","box":"Qualiphy_box__3DSxX","toggleWrap":"Qualiphy_toggleWrap__3Ferx"};